import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, retry, tap, throwError, timer } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../_shared/services/common.service';
import { Backend } from '../_models/backend';
import { AlertService } from '../_shared/components/alert/alert.service';
import ResponseCodes = Backend.ResponseCodes;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly RETRY_NUM = 3;
  private readonly RETRY_DELAY_MS = 1500;

  constructor(private authService: AuthService, private alert: AlertService, private commonService: CommonService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && event.body != null && event.body.warnings != null) {
        const warnings: ResponseCodes[] = event.body.warnings;

        for (const warning of warnings) {
          this.prepareAlert(warning);
        }
      }
    }), retry({count: this.RETRY_NUM, delay: (error, retryCount) => this.shouldRetry(error, retryCount)}), catchError(err => {
      if (err.status === 401 || err.status === 403) {
        if (request.url.indexOf('requestToken') === -1) {
          // auto logout if 401 response returned from api
          if (err.status === 401) {
            this.authService.logout();
          } else {
            this.commonService.baseService?.logMsg('API access error: ' + err.status + ' ' + err.statusText, 'ERROR').subscribe();
          }
        } else {
          if (request.url.indexOf('guest') !== -1) {
            this.alert.showDanger('ERROR.INVALID_QUIZ_CODE');
          } else if (request.url.indexOf('pairing') !== -1) {
              this.alert.showDanger('ERROR.INVALID_PAIRING_CODE');
          } else {
            this.alert.showDanger('ERROR.INVALID_USERNAME_OR_PASSWORD');
          }
        }
      } else {
        if (err.error == null || typeof err.error !== 'string') {
          const ticketId = err.error?.ticketId;

          if (ticketId != null) {
            this.alert.showDanger('ERROR.GENERAL_WITH_TICKET', {ticketId});
          } else {
            //this.alert.showDanger('ERROR.GENERAL');
          }
        } else {
          this.prepareAlert(err.error, err);
        }
      }
      return throwError(err);
    }));
  }

  private shouldRetry(error: HttpErrorResponse, count: number) {
    if (error.status >= 500 && error.status < 600) {
      let delay = 0;

      for (let i = 1; i <= count; i++) { // retry delay (1500 ms, 4500 ms, 9000ms)
        delay += i * this.RETRY_DELAY_MS;
      }
      return timer(delay);
    }
    throw error;
  }

  private prepareAlert(code: ResponseCodes, err: any = null): void {
    const msg = `RESPONSE_CODES.${code}`;

    switch (code) {
      case 'RESPONSE_CODE_PASSWORD_INVALID_FORMAT':
      case 'RESPONSE_CODE_PASSWORDS_NOT_MATCH':
      case 'RESPONSE_CODE_SAME_PASSWORDS':
        this.alert.showDanger(msg);
        break;
      default:
        const errorMessage = 'API access error: ' + (err != null ? err.status + ' ' + err.statusText + ' ' + err.message + ' ' : '') + code;
        this.commonService.baseService?.logMsg(errorMessage, 'ERROR').subscribe();
        //this.alert.showDanger('ERROR.GENERAL');
        break;
    }
  }
}
